import { render, staticRenderFns } from "./buttonSwitch.vue?vue&type=template&id=a16665d2&scoped=true&"
import script from "./buttonSwitch.vue?vue&type=script&lang=js&"
export * from "./buttonSwitch.vue?vue&type=script&lang=js&"
import style0 from "./buttonSwitch.vue?vue&type=style&index=0&id=a16665d2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16665d2",
  null
  
)

export default component.exports